import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/help")({ component: Help });
function Help() {
  return (
    <article className="mx-auto max-w-3xl space-y-8 px-6 py-32">
      <h1 className="text-4xl">Jotty for Mac help</h1>
      <section className="space-y-3">
        <h2 className="text-2xl">Before your first meeting</h2>
        <p>
          Sign in through your browser and return to Jotty. In Settings →
          Capture & permissions, grant microphone, accessibility and
          system-audio access. Calendar is optional. Start capture yourself when
          you are allowed to record; no meeting bot joins.
        </p>
      </section>
      <section className="space-y-3">
        <h2 className="text-2xl">Capture or sync needs attention</h2>
        <p>
          Open Capture & permissions and recheck access after changing macOS
          settings. Keep Jotty open while uploads finish. If edits are offline,
          reconnect and retry sync before signing out. Conflicting notes require
          you to choose which version to keep.
        </p>
      </section>
      <section className="space-y-3">
        <h2 className="text-2xl">Google Calendar</h2>
        <p>
          Connect Google after signing in to Jotty. If access expires or is
          revoked, reconnect from Calendar & meeting apps. Calendar does not
          become your login and does not grant access to your Gmail mailbox.
        </p>
      </section>
      <section className="space-y-3">
        <h2 className="text-2xl">Account and support</h2>
        <p>
          Use Account & support to open account management, invite teammates as
          an owner/admin, or send a password-reset email. Personal-account
          deletion is not an in-app action. For a data request or capture
          problem, contact Kugie.
        </p>
        <p>
          Run diagnostics, review the contents, and choose a file location
          before sharing it. The export excludes notes, transcripts, account
          identifiers and credentials. It is never sent automatically.
        </p>
        <a className="underline" href="https://kugie.app/">
          Contact Kugie ↗
        </a>
      </section>
    </article>
  );
}
